import DefaultConfig from './DefaultConfig'
import HeaderConfig from './HeaderConfig'
import FooterConfig from './FooterConfig'

export const Config = {

    /**
     *
     * @param type
     * @returns {DefaultConfig}
     */
    make(type) {
        if (typeof this.map[type] === 'undefined') {
            return new this.map.default;
        }

        return new this.map[type];
    },

    map: {
        default: DefaultConfig,
        header: HeaderConfig,
        footer: FooterConfig,
    }
}